<template>
  <div id="survey-overview">
    <div class="row">
      <div class="col s12">
        <div class="title-area">Flood Hazard Assessment</div>
        <div class="col s12">
         Will your home be safe in another <a href="#" helper-id="F9012">100-year flood</a>
         like the 2013 Christmas Eve Trough? Find out here 
         by telling us a bit more about the location and surroundings of your home, 
         past flood experiences and flood-resilient features that your home may have.
        </div>
      </div>
    </div>
    <div class="row flex wrap-items">

      <div class="col s6" v-for="(tool, index) in tools" :key="index">
        <div class="card hoverable">
          <div class="card-content">
         <!--<div class="icon-area" v-if="tool.icon">
              <img :src="tool.icon">
            </div> -->
            <span @click="$_goToStep(tool.toIndex, tool.toStep)" style="pointer:cursor" class="card-title indigo-text text-accent-5">
              {{tool.name}}
            </span>
          </div>
          <div class="action-container">
            <div class="card-action">
              <button
                class="btn btn-rounded indigo accent-5 waves-effect"
                @click="$_goToStep(tool.toIndex, tool.toStep)"
              >
                <span v-if="tool.toStep === 'exposure_flooding'"> {{ exposureStatusX }} </span>
                <span v-else-if="tool.toStep === 'vulnerability_flooding'"> {{ vulnerabilityStatusX }} </span>
                <span v-else>Review</span>
              </button>
            </div>
          </div>
          
        </div>
      </div>

    </div>

  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { schema } from "@/schemas/floodHazard";
export default {
  name: "FloodSurveyOverview",
  props: {},
  data() {
    return {
      tools:[
        {
          /* icon: water_shortage, */
          name: 'Exposure of Home to Flooding and Previous Flood Impact',
          buttonText: 'Start',
          toIndex: 1,
          toStep: 'exposure_flooding'
        },
        {
          /* icon: water_tank, */
          name: 'Resilience of Home to Flooding',
          buttonText: 'Start',
          toIndex: 2,
          toStep: 'vulnerability_flooding'
        },
        {
          /* icon: overview_icon, */
          name: 'Expected Impact Level',
          buttonText: 'Start',
          toIndex: 3,
          toStep: ''
        },

      ]
    }
  },
  mounted() {
    this.$_setupHelpers()
  },
  computed: {
    ...mapState({
      floodHazard: (state) => state.Surveys.floodHazard,
    }),
    exposureQuestionsX() {
      if (this.floodHazard && this.floodHazard.survey) {
        const val = Object.keys(schema).reduce((result, key) => {
          if (schema[key].section && schema[key].section === "exposure") {
            result[key] = this.floodHazard.survey[key];
          }
          return result;
        }, {});

        return val;
      }
      return {};
    },
    exposureStatusX() {
      const hasBegan = Object.values(this.exposureQuestionsX).some((item) => {
        if (typeof item === "object") {
          return item.length > 0 ? true : false;
        } else {
          return !!item;
        }
      });

      return hasBegan ? "Continue" : "Begin";
    },
    vulnerabilityQuestionsX() {
      if (this.floodHazard && this.floodHazard.survey) {
        const val = Object.keys(schema).reduce((result, key) => {
          if (schema[key].section && schema[key].section === "vulnerability") {
            result[key] = this.floodHazard.survey[key];
          }
          return result;
        }, {});

        return val;
      }
      return {};
    },
    vulnerabilityStatusX() {
      const hasBegan = Object.values(this.vulnerabilityQuestionsX).some(
        (item) => {
          if (typeof item === "object") {
            return item.length > 0 ? true : false;
          } else {
            return !!item;
          }
        }
      );

      return hasBegan ? "Continue" : "Begin";
    },
  },
  methods: {
  ...mapActions("Helpers", ["setHelper"]),
    $_goToStep(step, section) {
      this.$router.push({query:{editing:true}})
      this.$emit("updateStep", { step, section });
    },
    $_setupHelpers() {
      const helpers = this.$el.querySelectorAll("[helper-id]");

      if (helpers) {
        helpers.forEach((helperEl) => {
          helperEl.addEventListener("click", (event) => {
            event.preventDefault()
            const helperId = helperEl.getAttribute("helper-id")
            const styles = helperEl.getAttribute("helper-style")
            this.$store.dispatch("Helpers/setHelper_", {id:helperId, styles:styles ? styles : ''})
           /*  this.$store.dispatch("Helpers/setHelper", helperId); */
          });
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
#survey-overview {
  padding: 16px;
  max-width: 768px;
  margin: auto;
   .card {
    height: calc(100% - 1.5rem);
      .card-title {
        font-size: 17px;
        font-weight: 500;
        line-height: 20.5px;
        margin-top: 4px;
        margin-bottom: 4px;
      }
      .action-container {
        height: 58px;
        width: 100%;
          .card-action {
            padding-top: 0px;
            position: absolute;
            bottom: 0; left: 0; right: 0;
            border: none;
            width: 100%;
            button {
              width: 100%;
            }
          }
      } 
    }
  .title-area {
    font-size: 26px;
    margin: 12px 8px 2px;    
    position: relative;
  }
  }

</style>
